var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[_vm._v("正在思考中... "),_c('span',{staticClass:"loader"})])
}]

export { render, staticRenderFns }